exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".marketing-styles-messages .up-image-resp {\n  margin: 0px !important; }\n\n.marketing-styles-messages .up-image {\n  margin-bottom: -40px !important; }\n", ""]);

